var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhotography = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Camera-Flash--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Camera Flash Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.41 8h3.68a2.73 2.73 0 0 1 0.8 0.13 0.21 0.21 0 0 0 0.19 0 0.27 0.27 0 0 0 0.13 -0.13l0.27 -1a2 2 0 0 0 2 -2V2a2 2 0 0 0 -2 -2H10a2 2 0 0 0 -2 2v3a2 2 0 0 0 2 2l0.27 1a0.27 0.27 0 0 0 0.13 0.15 0.21 0.21 0 0 0 0.19 0 2.73 2.73 0 0 1 0.82 -0.15ZM10 2.5a0.5 0.5 0 0 1 0.5 -0.5H16a0.5 0.5 0 0 1 0.5 0.5v2a0.5 0.5 0 0 1 -0.5 0.5h-5.5a0.5 0.5 0 0 1 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.25a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0 -6.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11h-2.59a0.47 0.47 0 0 1 -0.35 -0.15l-1.41 -1.41A1.52 1.52 0 0 0 15.09 9h-3.68a1.52 1.52 0 0 0 -1.06 0.44l-1.41 1.41a0.47 0.47 0 0 1 -0.35 0.15H3.5A2.5 2.5 0 0 0 1 13.5v8A2.5 2.5 0 0 0 3.5 24h17a2.5 2.5 0 0 0 2.5 -2.5v-8a2.5 2.5 0 0 0 -2.5 -2.5ZM6 14.75a1.25 1.25 0 1 1 -1.25 -1.25A1.25 1.25 0 0 1 6 14.75Zm2 2.5a5.25 5.25 0 1 1 5.25 5.25A5.26 5.26 0 0 1 8 17.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5A1.5 1.5 0 0 0 5.5 8h-1A1.5 1.5 0 0 0 3 9.5a0.5 0.5 0 0 0 0.5 0.5h3a0.5 0.5 0 0 0 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhotography);
export default ForwardRef;